import { render, staticRenderFns } from "./TaskActivityBox.vue?vue&type=template&id=5a64d860&scoped=true"
import script from "./TaskActivityBox.vue?vue&type=script&lang=ts"
export * from "./TaskActivityBox.vue?vue&type=script&lang=ts"
import style0 from "./TaskActivityBox.vue?vue&type=style&index=0&id=5a64d860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64d860",
  null
  
)

export default component.exports